// Téléphone du passager (transport, lot T6, décision du 2026-11-01). Le serveur enregistre le format international
// (« +33611223344 », backend/metier.py : international_phone) ; l'écran demande l'indicatif dès qu'un numéro est tapé (sans
// valeur par défaut) et affiche le numéro lisiblement (« +33 6 11 22 33 44 »). Le lien d'appel reste « tel:+33611223344 ».
// Une seule liste d'indicatifs (revue du 2026-11-01) : celle du serveur (metier.PHONE_COUNTRIES), reçue avec les Réglages du
// transport (`phone_countries`) et retenue ici au chargement (SettingsContext). Aucune copie dans l'écran.

let LISTE = []; // [[indicatif, pays]] proposés dans la fenêtre de course
let CODES = []; // indicatifs reconnus sans « + », du plus long au plus court

// Appelé au chargement des Réglages ; en conciergerie, rien n'est reçu : la liste reste vide (aucune mise en forme).
export function rememberPhoneCountries(pc) {
  LISTE = Array.isArray(pc?.listed) ? pc.listed : [];
  CODES = Array.isArray(pc?.codes) ? [...pc.codes].sort((a, b) => b.length - a.length) : [];
}
export const phoneCountries = () => LISTE;

// Numéro déjà international (« +… » ou « 00… ») : l'indicatif n'est pas demandé.
export const isInternational = (v) => /^\s*(\+|00)/.test(v || "");

// « +33611223344 » → { code: "+33", national: "611223344" } ; null si ce n'est pas un numéro international enregistré.
export function splitInternational(v) {
  const s = String(v || "").trim();
  if (!/^\+\d{7,15}$/.test(s)) return null;
  const chiffres = s.slice(1);
  const code = CODES.find((c) => chiffres.startsWith(c) && chiffres.length - c.length >= 4);
  return code ? { code: `+${code}`, national: chiffres.slice(code.length) } : null;
}

// Chiffres nationaux par paires (« 6 11 22 33 44 », « 6 40 12 34 56 ») ; Amérique du Nord : 3-3-4.
function groupe(code, n) {
  if (code === "+1" && n.length === 10) return `${n.slice(0, 3)} ${n.slice(3, 6)} ${n.slice(6)}`;
  const tete = n.length % 2 ? n.slice(0, 1) : "";
  const reste = n.slice(tete.length).match(/.{1,2}/g) || [];
  return [tete, ...reste].filter(Boolean).join(" ");
}

// Affichage lisible : « +33611223344 » → « +33 6 11 22 33 44 ». Un numéro saisi autrement (ancienne course) : tel quel.
export function formatPhone(v) {
  const parts = splitInternational(v);
  return parts ? `${parts.code} ${groupe(parts.code, parts.national)}` : String(v || "");
}
